var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 3.875V0H6.45833V3.875H10.3333V6.45833H6.45833V10.3333H3.875V6.45833H0V3.875H3.875ZM7.75 11.625V7.75H11.625V3.875H20.6667L23.0304 6.45833H27.125C28.5458 6.45833 29.7083 7.62083 29.7083 9.04167V24.5417C29.7083 25.9625 28.5458 27.125 27.125 27.125H6.45833C5.0375 27.125 3.875 25.9625 3.875 24.5417V11.625H7.75ZM16.7917 23.25C20.3567 23.25 23.25 20.3567 23.25 16.7917C23.25 13.2267 20.3567 10.3333 16.7917 10.3333C13.2267 10.3333 10.3333 13.2267 10.3333 16.7917C10.3333 20.3567 13.2267 23.25 16.7917 23.25ZM12.6583 16.7917C12.6583 19.0779 14.5054 20.925 16.7917 20.925C19.0779 20.925 20.925 19.0779 20.925 16.7917C20.925 14.5054 19.0779 12.6583 16.7917 12.6583C14.5054 12.6583 12.6583 14.5054 12.6583 16.7917Z",
    fill: "#5751E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/addImage.34312c1a51aaa23f36aa2f3dcbe4a8e8.svg";
export { ForwardRef as ReactComponent };